import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { back } from 'redux-first-router';
import {
  Box,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import image500 from '../assets/img/error_500.svg';

const useStyles = makeStyles(theme => ({
  root: {
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    minHeight: '100%',
    padding: theme.spacing(3),
  },
  image: {
    maxWidth: '100%',
    width: 560,
    maxHeight: 300,
    height: 'auto',
  },
}));

const ErrorScreen = props => {
  const classes = useStyles();
  const { dispatch } = props;
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('md'));

  const handleClick = () => {
    dispatch(back());
  };

  return (
    <Box className={classes.root}>
      <Typography
        align="center"
        variant={mobileDevice ? 'h4' : 'h1'}
        color="textPrimary"
      >
        500: Ooops, something went terribly wrong!
      </Typography>
      <Typography align="center" variant="subtitle2" color="textSecondary">
        
          All errors are automatically reported and logged. Our team will fix
          this error asap!
        
      </Typography>
      <Box mt={6} display="flex" justifyContent="center">
        <img alt="Under development" className={classes.image} src={image500} />
      </Box>
      <Box mt={6} display="flex" justifyContent="center">
        <Button color="secondary" onClick={handleClick} variant="outlined">
          Back to home
        </Button>
      </Box>
    </Box>
  );
};

ErrorScreen.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

export default connect()(ErrorScreen);
